export function PreviousIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#808487"
        d="M11.2 7c0-.467-.18-.934-.533-1.287L6.32 1.366a.503.503 0 00-.707 0 .503.503 0 000 .707L9.96 6.42c.32.32.32.84 0 1.16l-4.347 4.346a.503.503 0 000 .707.503.503 0 00.707 0l4.347-4.347c.353-.353.533-.82.533-1.286z"
      ></path>
    </svg>
  );
}

export function NextIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#808487"
        d="M4.8 7c0-.467.18-.934.533-1.287L9.68 1.366a.503.503 0 01.707 0 .503.503 0 010 .707L6.04 6.42a.82.82 0 000 1.16l4.346 4.346a.503.503 0 010 .707.503.503 0 01-.706 0L5.333 8.286A1.818 1.818 0 014.8 7z"
      ></path>
    </svg>
  );
}
